<template>
  <div>
    <div class="row justify-content-between align-items-center">
      <div class="col-lg-3">
        <h3>{{ createPageTitle()}} </h3>
      </div>
      <div class="col-lg-3">
        <h4>
          <span v-if="fullTimeSheet.completed" class="text-green">BEVESTIGD</span>
          <span v-else class="text-red">NIET BEVESTIGD</span>
          <br>{{ this.currentlySelectedMonth | toMonthNameWithYear }}
        </h4>
      </div>
      <div class="col-lg-4">
        <button
            :disabled="!hasPreviousContract"
            id="btnPreviousContract" class="btn-basic btn-dark mr-1"
            style="width: 50px;"
            @click="previousContract">
          <svg
              class="bi bi-chevron-left" fill="currentColor"
              height="1em" viewBox="0 0 16 16"
              width="1em" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                fill-rule="evenodd"/>
          </svg>
        </button>
        <button
            :disabled="!hasNextContract"
            id="btnNextContract" class="btn-basic btn-dark mr-2"
            style="width: 50px;"
            @click="nextContract">
          <svg
              class="bi bi-chevron-left" fill="currentColor"
              height="1em" viewBox="0 0 16 16"
              width="1em" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                fill-rule="evenodd"/>
          </svg>
        </button>
        <button
            :disabled="!previousMonthAvailable"
            class="btn-basic btn-dark mx-1" @click="previousMonth"
            style="width: 50px;">
          <svg
              class="bi bi-chevron-left" fill="currentColor"
              height="1em" viewBox="0 0 16 16"
              width="1em" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                fill-rule="evenodd"/>
          </svg>
        </button>
        <button
            :disabled="!nextMonthAvailable"
            class="btn-basic btn-dark" @click="nextMonth"
            style="width: 50px;">
          <svg
              class="bi bi-chevron-right" fill="currentColor"
              height="1em" viewBox="0 0 16 16"
              width="1em" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                fill-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </div>
    <div class="row table-responsive">
      <table class="table table-bordered">
        <thead class="thead-dark">
        <tr>
          <SortableTableHeaderComponent
              columnName="dateFormatted" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Datum"/>
          <SortableTableHeaderComponent
              columnName="weekDay" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Weekdag"/>
          <SortableTableHeaderComponent
              columnName="sickness" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Ziekte"/>
          <SortableTableHeaderComponent
              columnName="vacation" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Vakantie"/>
          <SortableTableHeaderComponent
              columnName="recuperation" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Recuperatie"/>
          <SortableTableHeaderComponent
              columnName="Intern" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Intern"/>
          <SortableTableHeaderComponent
              columnName="Div afw" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="diff"/>
          <SortableTableHeaderComponent
              columnName="Totaal" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Totaal"/>
          <SortableTableHeaderComponent
              columnName="startTime" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Starttijd"/>
          <SortableTableHeaderComponent
              columnName="endTime" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Eindtijd"/>
          <SortableTableHeaderComponent
              columnName="breakStartTime" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Start pauze"/>
          <SortableTableHeaderComponent
              columnName="breakEndTime" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Einde pauze"/>
          <SortableTableHeaderComponent
              columnName="callout24" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Oproep 24"/>
          <SortableTableHeaderComponent
              columnName="callout48" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Oproep 48"/>
          <SortableTableHeaderComponent
              columnName="interrupted" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Onderbroken"/>
          <SortableTableHeaderComponent
              columnName="remark" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Opmerking"/>
        </tr>
        </thead>
        <tbody>
        <template v-for="(object, index) in sortedTimeSheetObjects">
          <tr :key="index">
            <td>{{ object.dateFormatted }}</td>
            <td>{{ object.weekDay }}</td>
            <td>{{ object.sickness | convertDotToCommaInNumber }}</td>
            <td>{{ object.vacation | convertDotToCommaInNumber }}</td>
            <td>{{ object.recuperation | convertDotToCommaInNumber }}</td>
            <td></td>
            <td>{{ object.diff }}</td>
            <td></td>
            <td>{{ object.startTime }}</td>
            <td>{{ object.endTime }}</td>
            <td>{{ object.breakStartTime }}</td>
            <td>{{ object.breakEndTime }}</td>
            <td>{{ object.callout24 }}</td>
            <td>{{ object.callout48 }}</td>
            <td>{{ object.interrupted }}</td>
            <td>{{ object.remark }}</td>
          </tr>
        </template>

        </tbody>
      </table>
      <button
          class="btn-basic btn-teal"
          @click="openTimesheet()">
        Bewerken
      </button>
    </div>
    <button
        class="btn btn-primary mr-3 mb-4"
        @click="previewInvoice()">Genereer nieuwe factuur</button>
    <div v-if="selectedInvoice != null">
      <div class="row d-block">
        <h5 class="mt-5 mb-4">Preview Factuur</h5>
      </div>
      <div class="row table-responsive">
        <table class="table table-striped">
          <thead class="thead-dark">
            <tr>
              <th>Gewerkte uren</th>
              <th>Totaal facturatiebedrag</th>
              <th>Actie</th>
            </tr>
          </thead>
          <tbody>
            <td>{{ selectedInvoice.billDto.totalWorkedHours }}</td>
            <td>€ {{ selectedInvoice.billDto.totalAmountAllShifts }}</td>
            <td><button class="btn btn-success mr-3" @click="openInvoice(selectedInvoice.id)">Pas factuur aan</button></td>
          </tbody>
        </table>
      </div>

      <div class="row d-block">
        <h5 class="mt-5 mb-4">Preview vrije kosten</h5>
      </div>
      <div class="row table-responsive">
        <table class="table table-striped">
          <thead class="thead-dark">
          <tr>
            <th>Omschrijving</th>
            <th>Totaal vrije kost</th>
          </tr>
          </thead>
          <tbody v-for="freeCostDto in selectedInvoice.freeCosts" v-bind:key="freeCostDto.id">
          <td>{{ freeCostDto.description }}</td>
          <td>€ {{ freeCostDto.total }}</td>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import moment from "moment";
import CallOuts from "@/constants/CallOuts";
import {
  isExcusedAbsence,
  isPersonalLeave,
  isRecup,
  isSickness,
  isVacation,
  toAbsenceObject
} from "@/constants/Absences";
import {sortListByColumnAndDirection} from "@/util/SortingUtil";
import SortableTableHeaderComponent from "@/components/tables/SortableTableHeader";

export default {
  name: "AdminViewExcel",
  components: {SortableTableHeaderComponent},
  data: () => ({
    currentSortColumn: "dateFormatted",
    currentSortDirectionAscending: true,
    selectedHourlyRate: null,
  }),
  computed: {
    ...mapGetters({
      contractsWithTimeSheetInfo: "administrationTimeSheet/contractWithTimeSheetInfo",
      fullTimeSheet: "administrationTimeSheet/fullTimeSheet",
      selectedTimeSheetInfo: "administrationTimeSheet/selectedTimeSheetInfo",
      currentlySelectedContractId: "administrationTimeSheet/currentlySelectedContractId",
      currentlySelectedContractIndex: "administrationTimeSheet/currentlySelectedContractIndex",
      previousMonthAvailable: "administrationTimeSheet/previousMonthAvailable",
      nextMonthAvailable: "administrationTimeSheet/nextMonthAvailable",
      hasPreviousContract: "administrationTimeSheet/hasPreviousContract",
      hasNextContract: "administrationTimeSheet/hasNextContract",
      previousContractWithTimeSheetInfo: "administrationTimeSheet/previousContractWithTimeSheetInfo",
      nextContractWithTimeSheetInfo: "administrationTimeSheet/nextContractWithTimeSheetInfo",
      currentlySelectedMonth: "time/currentlySelectedMonth",
      selectedContract: "administrationContract/selectedContract",
      selectedInvoice: "administrationInvoice/selectedInvoice"
    }),
    sortedTimeSheetObjects() {
      const workedShiftRows = this.getWorkedShiftRows();
      const absenceRows = this.getAbsenceRows();
      const rows = [...workedShiftRows, ...absenceRows];

      if (this.currentSortColumn === "callout24" || this.currentSortColumn === "callout48" || this.currentSortColumn === "interrupted") {
        return sortListByColumnAndDirection(rows, this.currentSortColumn, this.currentSortDirectionAscending, this.checkedFirst);
      }
      return sortListByColumnAndDirection(rows, this.currentSortColumn, this.currentSortDirectionAscending);
    }
  },
  created() {
    this.fetchFullTimeSheet();
    this.previousContractAvailable();
    this.nextContractAvailable();
    this.findInvoice();
  },
  methods: {
    ...mapActions("administrationTimeSheet", ["fetchFullTimeSheet"]),
    ...mapActions("administrationInvoice", ["calculateInvoice", "fetchInvoice", "findInvoice", "fetchAccountingCostsList"]),
    ...mapActions("administrationContract", ["addHourlyRateToContract","fetchSelectedContractById"]),
    ...mapMutations({
      addMonth: "time/addMonth",
      subtractMonth: "time/subtractMonth",
      setSelectedCustomerTimesheetInfo: "administrationTimeSheet/setSelectedCustomerTimesheetInfo",
      setCurrentlySelectedContractId: "administrationTimeSheet/setCurrentlySelectedContractId",
      setCurrentlySelectedContractIndex: "administrationTimeSheet/setCurrentlySelectedContractIndex",
      setPreviousMonthAvailable: "administrationTimeSheet/setPreviousMonthAvailable",
      setHasPreviousContract: "administrationTimeSheet/setHasPreviousContract",
      setSelectedInvoice: "administrationInvoice/setSelectedInvoice",
      setHasNextContract: "administrationTimeSheet/setHasNextContract",
      setCurrentlySelectedUserId: "administrationTimeSheet/setCurrentlySelectedUserId"
    }),
    openTimesheet() {
      this.$router.push({ name: "adminDetails"});
    },
    openInvoice() {
      this.fetchInvoice();
      this.$router.push({path: "/admin/viewinvoicedetail"});
    },
    previewInvoice() {
      if (!this.validateHourlyRate()) return;
      this.$router.push({ name: "adminViewInvoicePreview"});
    },
    validateHourlyRate() {
      let hourlyRatesAvailable = this.fullTimeSheet.orders.length > 0;
      let currentMonth = new Date(this.currentlySelectedMonth);

      if (hourlyRatesAvailable) {
        if (this.hasHourlyRatesCurrentMonth(currentMonth)) return true;
        if (this.hasHourlyRatesPreviousMonth(currentMonth)) {
          let extend = confirm(`Er is geen geldig uurtarief gevonden voor ${currentMonth.toLocaleString("NL-NL", {month: "long"})} ${currentMonth.getFullYear()}. \nWilt u het uurtarief (${this.selectedHourlyRate.baseHourlyRate} euro) van afgelopen maand verlengen?`);

          if (extend) {
            let startDate = new Date(this.selectedHourlyRate.endDate);
            startDate.setDate(startDate.getDate() + 1);
            let endDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth() +1, 0);

            let createHourlyRateDto = {
              startDate: this.convertDateTo_YYYY_MM_DD(startDate),
              endDate: this.convertDateTo_YYYY_MM_DD(endDate),
              baseHourlyRate: this.selectedHourlyRate.baseHourlyRate,
              internalReference: this.selectedHourlyRate.internalReference,
              externalReference: this.selectedHourlyRate.externalReference
            };
            let data = {
              contractId: this.currentlySelectedContractId,
              createOrderDto: createHourlyRateDto,
            };
            this.addHourlyRateToContract(data);
            this.fetchSelectedContractById(this.currentlySelectedContractId);
          }
          return extend;
        }
      }

      alert(`Er is geen geldig uurtarief gevonden voor ${currentMonth.toLocaleString("NL-NL", {month: "long"})} ${currentMonth.getFullYear()}. \nEen geldig uurtarief eindigt ten vroegste op de laatste dag van deze maand.`);
      return false;
    },
    hasHourlyRatesCurrentMonth(month) {
      let hourlyRates = this.selectedContract.orders;
      let lastDayCurrentMonth = new Date(month.getFullYear(), month.getMonth()+1, 0);

      for (const hourlyRate of hourlyRates) {
        let [year, month, day] = hourlyRate.startDate.split('-');
        let startDate = new Date(year, month-1,day);
        let [yearEnd, monthEnd, dayEnd] = hourlyRate.endDate.split('-');
        let endDate = new Date(yearEnd, monthEnd-1,dayEnd);
        if (startDate <= lastDayCurrentMonth && endDate >= lastDayCurrentMonth) return true;
      }

      return false;
    },
    hasHourlyRatesPreviousMonth(month) {
      let hourlyRates = this.selectedContract.orders;
      let firstDayPreviousMonth = new Date(month.getFullYear(), month.getMonth() -1, 1);
      let lastDayCurrentMonth = new Date(month.getFullYear(), month.getMonth() +1, 0);
      let eligibleHourlyRates = [];

      for (const hourlyRate of hourlyRates) {
        let endDate = new Date(hourlyRate.endDate);
        if (endDate >= firstDayPreviousMonth && endDate <= lastDayCurrentMonth) {eligibleHourlyRates.push(hourlyRate);}
      }

      if (eligibleHourlyRates.length > 0) {
        this.selectedHourlyRate = eligibleHourlyRates.sort((a,b) => a.endDate.localeCompare(b.endDate)).reverse()[0];
        return true;
      }

      return false;
    },
    convertDateTo_YYYY_MM_DD(date) {
      return date.getFullYear() + "-" + ((date.getMonth() + 1) + "").padStart(2, '0') + "-" + (date.getDate() + "").padStart(2, '0');
    },
    createNewInvoice() {
      this.calculateInvoice(this.selectedTimeSheetInfo);
      this.$router.push({ name: "adminViewInvoice"});
    },
    previousMonth() {
      this.subtractMonth();
      this.fetchFullTimeSheet();
    },
    nextMonth() {
      this.addMonth();
      this.fetchFullTimeSheet();
    },
    previousContractAvailable() {
      this.setHasPreviousContract(this.currentlySelectedContractIndex > 1);
    },
    nextContractAvailable() {
      this.setHasNextContract(this.contractsWithTimeSheetInfo.length > this.currentlySelectedContractIndex);
    },
    previousContract() {
      let previousContract = this.previousContractWithTimeSheetInfo;
      this.setCurrentlySelectedContractId(previousContract.contractId);
      this.setCurrentlySelectedContractIndex(this.currentlySelectedContractIndex -1);
      this.setSelectedCustomerTimesheetInfo(previousContract);
      this.fetchFullTimeSheet();
      this.previousContractAvailable();
      this.nextContractAvailable();
      this.setCurrentlySelectedUserId(previousContract.userId);
    },
    nextContract() {
      let nextContract = this.nextContractWithTimeSheetInfo;
      this.setCurrentlySelectedContractId(nextContract.contractId);
      this.setCurrentlySelectedContractIndex(this.currentlySelectedContractIndex +1);
      this.setSelectedCustomerTimesheetInfo(nextContract);
      this.fetchFullTimeSheet();
      this.previousContractAvailable();
      this.nextContractAvailable();
      this.setCurrentlySelectedUserId(nextContract.userId);
    },
    getWorkedShiftRows() {
      const result = [];
      this.fullTimeSheet.workedShiftDtos?.forEach((workedShift) => {
        result.push(this.mapWorkedShiftToRowData(workedShift));
      });
      return result;
    },
    mapWorkedShiftToRowData(workedShift) {
      const rowData = {
        date: moment(workedShift.labourPeriod.startDateTimestamp),
        dateFormatted: moment(workedShift.labourPeriod.startDateTimestamp).format("DD-MM"),
        weekDay: moment(workedShift.labourPeriod.startDateTimestamp).format("ddd"),
        sickness: 0,
        vacation: 0,
        recuperation: 0,
        diff: 0,
        startTime: moment(workedShift.labourPeriod.startDateTimestamp).format("HH:mm"),
        endTime: moment(workedShift.labourPeriod.endDateTimestamp).format("HH:mm"),
        breakStartTime: '',
        breakEndTime: '',
      };
      if (workedShift.breakPeriod) {
        rowData.breakStartTime = moment(workedShift.breakPeriod.startDateTimestamp).format('HH:mm');
        rowData.breakEndTime = moment(workedShift.breakPeriod.endDateTimestamp).format('HH:mm');
      }
      rowData.remark = workedShift.remark;

      rowData.interrupted = workedShift.interrupted ? "x" : '';
      rowData.callout24 = workedShift.callout === CallOuts.CALL_OUT_24 ? "x" : '';
      rowData.callout48 = workedShift.callout === CallOuts.CALL_OUT_48 ? "x" : '';
      return rowData;
    },
    getAbsenceRows() {
      const result = [];
      this.fullTimeSheet.absenceDtos?.forEach(absenceDto => {
        result.push(this.mapAbsenceDtoToRowData(absenceDto));
      });
      return result;
    },
    mapAbsenceDtoToRowData(absenceDto) {
      const absence = toAbsenceObject(absenceDto);

      return {
        date: moment(absenceDto.date),
        dateFormatted: moment(absenceDto.date).format("DD-MM"),
        weekDay: moment(absenceDto.date).format("ddd"),
        sickness: isSickness(absence) ? absenceDto.hours : 0,
        vacation: isVacation(absence) ? absenceDto.hours : 0,
        recuperation: isRecup(absence) ? absenceDto.hours : 0,
        excusedAbsence: isExcusedAbsence(absence) ? absenceDto.hours : 0,
        personalLeave: isPersonalLeave(absence) ? absenceDto.hours : 0,
        diff: 0,
      };
    },
    createPageTitle() {
      return this.selectedTimeSheetInfo.username + " - " + this.selectedTimeSheetInfo.customerName;
    },
    dateToMillis(date) {
      return moment(date).valueOf();
    },
    checkedFirst(checked) {
      return !checked;
    },
    sort: function (newSortColumn) {
      if (newSortColumn === this.currentSortColumn) {
        this.currentSortDirectionAscending = !this.currentSortDirectionAscending;
      } else {
        this.currentSortDirectionAscending = true;
      }
      this.currentSortColumn = newSortColumn;
    }
  }
};
</script>

<style scoped>
.text-red {
  color: red;
}

.text-green {
  color: green;
}

#btnPreviousContract > svg {
  transform: rotate(90deg);
}

#btnNextContract > svg {
  transform: rotate(270deg);
}
</style>
